"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1894],{

/***/ 81894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NewsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./styles/jss/Home.styles.js
var Home_styles = __webpack_require__(47728);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 2 modules
var Container = __webpack_require__(53156);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./components/NextImage.jsx
var NextImage = __webpack_require__(68164);
// EXTERNAL MODULE: ./components/DateStamp.jsx
var DateStamp = __webpack_require__(89411);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/helperFunction.js
var helperFunction = __webpack_require__(18991);
;// CONCATENATED MODULE: ./components/PagesComponents/Home/NewsItemBox.jsx








function NewsItemBox(_param) {
    var height = _param.height, width = _param.width, typeSize = _param.typeSize, data = (0,_object_without_properties/* default */.Z)(_param, [
        "height",
        "width",
        "typeSize"
    ]);
    var ref, ref1;
    var locale = (0,router.useRouter)().locale;
    var id = data.id, _attributes = data.attributes, slug = _attributes.slug, thumbnail = _attributes.thumbnail, title = _attributes.title, datetime = _attributes.datetime;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "media-center/news/".concat(id, "/").concat(slug),
        locale: locale,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Home_styles/* NewsItem */.ns, {
                type: typeSize,
                height: height,
                width: width,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        className: "imageWrapper",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                            src: (ref1 = (0,helperFunction/* getImageUrl */.Jn)((ref = thumbnail.data) === null || ref === void 0 ? void 0 : ref.attributes.formats, [
                                "large",
                                "medium", 
                            ])) === null || ref1 === void 0 ? void 0 : ref1.url,
                            alt: title,
                            layout: "fill",
                            objectFit: "cover",
                            placeholder: "blur"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        className: "content",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                                date: datetime
                            })
                        ]
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 30 modules
var esm = __webpack_require__(58731);
;// CONCATENATED MODULE: ./components/PagesComponents/Home/NewsListItem.jsx









function NewsListItem(param) {
    var news = param.news;
    var locale = (0,router.useRouter)().locale;
    var t = (0,esm/* useTranslation */.$G)([
        "homePage"
    ]).t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Home_styles/* NewsList */.pY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h3", {
                        children: t("latest-news")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: "media-center/news",
                        locale: locale,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: t("see-all")
                            })
                        })
                    })
                ]
            }),
            !!news.slice(3, 9).length && news.slice(3, 9).map(function(param) {
                var id = param.id, attributes = param.attributes;
                var ref, ref1, ref2, ref3, ref4, ref5;
                var slug = attributes.slug, title = attributes.title, thumbnail = attributes.thumbnail, datetime = attributes.datetime;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Home_styles/* NewsBox */.v3, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "media-center/news/".concat(id, "/").concat(slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            children: (0,helperFunction/* truncateString */.aS)(title, 50)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DateStamp/* default */.Z, {
                                    date: datetime
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "imageWrapper",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NextImage/* default */.Z, {
                                layout: "responsive",
                                width: 100,
                                height: 100,
                                src: (ref = thumbnail.data) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.formats) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.url,
                                alt: (ref4 = thumbnail.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.caption,
                                placeholder: "blur"
                            })
                        })
                    ]
                }, id);
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Title/index.jsx + 4 modules
var Title = __webpack_require__(79245);
// EXTERNAL MODULE: ./components/Loader.jsx + 1 modules
var Loader = __webpack_require__(85232);
;// CONCATENATED MODULE: ./components/PagesComponents/Home/NewsSection.jsx











function NewsSection(param) {
    var news = param.news, isLoading = param.isLoading, isErrorNews = param.isErrorNews;
    var ref, ref1, ref2;
    var t = (0,esm/* useTranslation */.$G)([
        "homePage"
    ]).t;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Home_styles/* NewsWrapper */.UV, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
            sx: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("sm"), {
                p: 0
            }),
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title/* MainTitle */.U3, {
                    textAlign: "center",
                    children: t("news-title")
                }),
                isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {}) : !isErrorNews && !(0,helperFunction/* isEmpty */.xb)(news.data) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                    container: true,
                    rowSpacing: {
                        xs: 4,
                        lg: 0
                    },
                    columnSpacing: {
                        sm: 0,
                        md: 2,
                        lg: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            lg: 8,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
                                container: true,
                                rowSpacing: {
                                    xs: 0,
                                    sm: 1.5
                                },
                                columnSpacing: {
                                    xs: 1.5
                                },
                                children: [
                                    !!((ref = news === null || news === void 0 ? void 0 : news.data[0]) === null || ref === void 0 ? void 0 : ref.attributes) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 12,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsItemBox, (0,_object_spread/* default */.Z)({
                                            typeSize: "lg",
                                            width: 747,
                                            height: 520
                                        }, news === null || news === void 0 ? void 0 : news.data[0]))
                                    }),
                                    !!((ref1 = news === null || news === void 0 ? void 0 : news.data[1]) === null || ref1 === void 0 ? void 0 : ref1.attributes) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsItemBox, (0,_object_spread/* default */.Z)({
                                            typeSize: "sm",
                                            width: 369,
                                            height: 296
                                        }, news === null || news === void 0 ? void 0 : news.data[1]))
                                    }),
                                    !!((ref2 = news === null || news === void 0 ? void 0 : news.data[2]) === null || ref2 === void 0 ? void 0 : ref2.attributes) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                                        item: true,
                                        xs: 12,
                                        sm: 6,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsItemBox, (0,_object_spread/* default */.Z)({
                                            typeSize: "sm",
                                            width: 369,
                                            height: 296
                                        }, news === null || news === void 0 ? void 0 : news.data[2]))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            lg: 4,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsListItem, {
                                news: news === null || news === void 0 ? void 0 : news.data
                            })
                        })
                    ]
                }) : ""
            ]
        })
    });
};


/***/ }),

/***/ 79245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_P": function() { return /* reexport */ MainSubTitle; },
  "U3": function() { return /* reexport */ MainTitle; },
  "ll": function() { return /* reexport */ SecondSubTitle; },
  "oK": function() { return /* reexport */ SecondTitle; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./styles/jss/Layout.styles.js
var Layout_styles = __webpack_require__(48231);
;// CONCATENATED MODULE: ./components/Title/MainTitle.jsx


function MainTitle(param) {
    var children = param.children, className = param.className, color = param.color, textAlign = param.textAlign;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles.H2, {
        className: className,
        color: color,
        textAlign: textAlign,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/MainSubTitle.jsx


function MainSubTitle(param) {
    var children = param.children, className = param.className, textAlign = param.textAlign, color = param.color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* SubTitleParagraph */.G9, {
        className: className,
        textAlign: textAlign,
        color: color,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/SecondTitle.jsx


function SecondTitle(param) {
    var children = param.children, classname = param.classname;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles.H4, {
        className: classname,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/SecondSubTitle.jsx


function SecondSubTitle(param) {
    var children = param.children, classname = param.classname;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Layout_styles/* SecondSubTitleParagraph */.Mp, {
        className: classname,
        children: children
    });
};

;// CONCATENATED MODULE: ./components/Title/index.jsx






/***/ })

}]);